/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/PendingJourneysPageQuery$parameters.ts';

import type { PendingJourneysPageQuery } from './__generated__/PendingJourneysPageQuery.graphql.ts';

type Queries = {
	pendingJourneysQuery: PendingJourneysPageQuery;
};

type PendingJourneysEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const pendingJourneysEntryPoint: EntryPoint<
	PendingJourneysEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<PendingJourneysEntryPointComponent>(
		/* webpackChunkName: "async-journeys-pending-journeys", jiraSpaEntry: "async-journeys-pending-journeys" */ './PendingJourneysPage.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			pendingJourneysQuery: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey || null,
				},
			},
		},
		entryPoints: {},
		extraProps: {},
	}),
});
